import React from 'react';
import styled from '@emotion/styled';
import { MessageTemplateShare as MessageTemplate } from '~/types/models';
import CsrfToken from '~/App/Components/CsrfToken';

interface VideoLibraryCtaProps {
  messageTemplate: MessageTemplate;
  recordingId: string;
}

const CtaClickForm = styled.form`
  margin: 0;
`;

export default function VideoLibraryCta({
  messageTemplate,
  recordingId,
}: VideoLibraryCtaProps) {
  return (
    <div className='comment-cta option-cta'>
      <CtaClickForm
        action={`/r/${recordingId}/click`}
        method='POST'
        target='_blank'
      >
        <CsrfToken />
        <button
          type='submit'
          id='cta-button'
          style={{
            color: messageTemplate.primary_color,
            border: `0.15rem solid ${messageTemplate.color}`,
            backgroundColor: messageTemplate.cta.color,
          }}
        >
          {messageTemplate.cta.text}{' '}
          {messageTemplate.cta.text.length < 25 && (
            <i className='fas fa-external-link'></i>
          )}
        </button>
      </CtaClickForm>
    </div>
  );
}
